<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <!-- <el-form-item label="电台名称">
            <el-input
              v-model="queryForm.psp_order_id"
              placeholder="请输入电台名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              clearable
          >
          </el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <!-- <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="fetchData"
            >
              查询
            </el-button> -->
            <el-button @click="handleAdd" icon="el-icon-plus" v-hasPermi="['Island:radiosort:add']" type="primary">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="分类名称"
          prop="name"
          height="500"
        />
        <el-table-column
          align="center"
          label="创建日期"
          prop="insert_time"
        >
          <template #default="{ row }">
            <p>{{ transTime(row.insert_time) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="排序"
          prop="order_by"
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:radiosort:edit']"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:radiosort:delete']"
              @click="handleDelete(row)"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      /> -->
    </el-card>
    <el-dialog
      :title="type === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="beforeClose"
      center
    >
    <el-form
        ref="dialogForm"
        :model="dialogForm"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="分类名称" prop="typeName">
          <el-input placeholder="请输入分类名称" v-model="dialogForm.typeName" style="width: 100%" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number 
            v-model="dialogForm.sortValue"
            :min="1"
            controls-position="right"
            size="small"
          />
        </el-form-item>
        <el-form-item label="分类图片" prop="fileProp">
          <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
          <span>点亮</span>
          <UploadFile
            :limit="1"
            :fileList="fileList"
            :fileMaxSize="2"
            :accept="'.jpg,.jpeg,.png'"
            :value="dialogForm.fileProp"
            :httpRequest="uploadFile"
            :handleRemove="handleRemove"
          >
          </UploadFile>
          <span>未点亮</span>
          <UploadFile
            :limit="1"
            :fileList="fileList2"
            :fileMaxSize="2"
            :accept="'.jpg,.jpeg,.png'"
            :value="dialogForm.fileProp2"
            :httpRequest="uploadFile2"
            :handleRemove="handleRemove2"
          >
          </UploadFile>
        </el-form-item>
        <div class="dialog-bottom">
          <el-button @click="beforeClose">取 消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleT" custom-class="previewImg">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { getTranslateTypeList, createTranslateType, updateTranslateType, delTranslateType, uploadFiles } from "@/api/radio"
import { transTime } from "@/utils/transTime"
import { getImgName } from "@/utils/cutImgName"
import UploadFile from "@/components/uploadFile"

export default {
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisibleT: false,
      dialogImageUrl: '',
      getImgName,
      rules: {
        typeName: {
          required: true,
          message: "请输入分类名称",
          trigger: "blur",
        },
        fileProp: { required: true, message: '请上传文件', trigger: 'change'},
        fileProp2: { required: true, message: '请上传文件', trigger: 'change'},
      },
      transTime,
      type: '',
      dialogVisible: false,
      queryForm: {
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogForm: {
        fileProp: '',
        fileProp2: '',
        typeName: '',
        sortValue: ''
      }, // 模态框展示的数据
      fileList: [],
      fileList2: [],
      tableData: [],
      typeId: null,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    dateChange(val){
      const [ start, end ] = val;
      console.log(start, end)
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleAdd(){
      this.type = 'add'
      this.fileProp = ''
      this.fileProp2 = ''
      this.dialogForm.sortValue = this.tableData.length ? (this.tableData[0].order_by + 1) : 1
      this.fileList = []
      this.fileList2 = []
      this.dialogForm.typeName = ''
      this.dialogVisible = true
    },
    handleEdit(row) {
      console.log(row)
      this.type = 'edit'
      this.typeId = row.id
      this.dialogForm.sortValue = row.order_by
      this.dialogForm.typeName = row.name
      this.dialogForm.fileProp = row.icon
      this.dialogForm.fileProp2 = row.icon_unselected
      this.fileList = [
        {
          name: this.getImgName(row.icon),
          url: row.icon,
        },
      ]
      this.fileList2 = [
        {
          name: this.getImgName(row.icon_unselected),
          url: row.icon_unselected,
        },
      ]
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTranslateType({ id: row.id }).then(res => {
          console.log(res)
          this.fetchData()
        }).catch(err => {
          this.$message.error(err.msg)
        })
      })
    },
    fetchData() {
      getTranslateTypeList().then((res) => {
        if (res && res.data) {
          this.tableData = res.data
        }
      })
      .catch((e) => {
        console.log(e);
      });
    },
    beforeClose(){
      this.dialogForm.typeName = ''
      this.dialogForm.fileProp = ''
      this.dialogForm.fileProp2 = ''
      this.fileList = []
      this.fileList2 = []
      this.$refs.dialogForm.resetFields()
      this.dialogVisible = false
    },
    handleChange(file) {
      const isLt5M = file.size / 1024 / 1024 < 2;
      if (!isLt5M) {
        this.$message({
          showClose: true,
          message: "文件大小不能超过 2MB",
          type: "warning",
        });
        return false;
      }
    },
    uploadFile(params) {
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp = res.data.filePath
        }
      })
    },
    uploadFile2(params){
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp2 = res.data.filePath
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
    },
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
      this.dialogForm.fileProp2 = ''
    },
    submit(){
      if(this.type == 'add'){
        let name = this.dialogForm.typeName
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              createTranslateType({ name, icon: this.dialogForm.fileProp, icon_unselected: this.dialogForm.fileProp2, order_by: this.dialogForm.sortValue }).then(res => {
                if(res && res.code){
                  this.dialogVisible = false
                  this.fetchData()
                }
              })
            })
          }
        })
        
      } else {
        let name = this.dialogForm.typeName
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateTranslateType({ name, id: this.typeId, icon: this.dialogForm.fileProp, icon_unselected: this.dialogForm.fileProp2, order_by: this.dialogForm.sortValue }).then(res => {
                if(res && res.code){
                  this.dialogVisible = false
                  this.fetchData()
                }
              })
            })
          }
        })
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.tableCard {
  margin-top: 20px;
}

.file-tip{
  color: red;
  font-weight: 600;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.dialog-bottom{
  text-align: center;
}

</style>